define('apps/classrooms/views/modals/bulk_set_qr_distribute',[
    'app',
    'i18next',
    'njs!apps/classrooms/templates/includes/components/_bulk_qr_distribute(params:tmpl=classrooms/includes/components/_bulk_qr_distribute.html)',
    "vendor/jspdf/jspdf",
    "vendor/jszip/jszip",
    "vendor/jszip-utils/jszip-utils",
    "vendor/jsfilesaver/jsfilesaver",
    "apps/classrooms/views/pdf-utils/common",
    'apps/classrooms/views/pdf-utils/generate-per-page-pdf-download',
    'apps/classrooms/views/pdf-utils/generate-label-pdf-download',
    'apps/classrooms/views/pdf-utils/generate-table-pdf-download',
    'apps/classrooms/views/pdf-utils/generate-grid-pdf-download',
], function(
    app,
    i18next,
    template,
    jspdf,
    JSZip,
    jsZipUtils,
    jsFilesaver,
    pdfCommonUtils,
    generatePerPagePdfDownload,
    generateLabelPdfDownload,
    generateTablePdfDownload,
    generateGridPdfDownload
) {
    'use strict';

    return Mn.ItemView.extend({
        "className": "distribute",

        "template": template,

        "events": {
            "change .distribute input[type=radio]": "enableDownload",
            "click #bulk_qr_distribute": "printStudentQRs",
        },

        "initialize": function(opts) {
            this.model.set({
                "countryCode": this.model.get("countryCode"),
            });
        },

        /**
         * After user has selected a print layout, set model and enabled download button.
         */
         "enableDownload": function(e) {
            this.model.set('selectedLayout', e.target.value);

            this.$('#bulk_qr_distribute')
                .removeClass('comet-button--disabled')
                .attr('disabled', false);
        },

        /**
         * Callback after a user has selected a print layout. After verifying we
         *  a selection, we close the modal and then call the selected print format.
         */
         "printStudentQRs": function(e) {
            // since we are not rendering the template to build PDFs and
            //  zip files, derive path from page.init_data to be used
            //  when building zip download files.
            var initData = app.get('initData'),
                fullPath = initData.get('full_path'),
                pathWithoutParams = initData.get('path_without_params'),
                selectedLayout = this.model.get('selectedLayout');

            // if we do not have a full path for DE, lets parse out using localhost.
            if (!!fullPath) {
                this.model.set(
                    'currentDomain',
                    fullPath.split(pathWithoutParams)[0]
                );
            } else {
                this.model.set(
                    'currentDomain',
                    window.location.protocol + '//' + window.location.host.replace('admin.', 'app.')
                );
            }

            if (!!selectedLayout) {
                // after user has made a layout selection, lets see what
                //  print method they need and lets generate our qr codes and
                //  trigger a download
                switch (selectedLayout) {
                    case "5160":
                        generateLabelPdfDownload(true, this.model, true);
                        break;
                    case "22806":
                        generateTablePdfDownload(true, this.model, true);
                        break;
                    case "single":
                        generatePerPagePdfDownload(true, this.model, true);
                        break;
                    case "L712125":
                        generateGridPdfDownload(true, this.model, true);
                        break;
                    default:
                        // no template select. nothing to do.
                        return;
                }

                this.printDownloadSuccess();
            }
        },

        "printDownloadSuccess": function() {
            var $container = $(this.el);

            $container.find('.distribute').addClass('bulk-qr-form__elem--hidden');
            $container.find('.download-complete ').removeClass('bulk-qr-form__elem--hidden');

            $('.qr-back-btn').data('status', 'success');
        },
    });
});

